import IntersectSquare from "@uui/IntersectSquare";

import { IntegrationDetailContent } from "@app/analytics/Integrations/styles";
import type { Integration } from "@app/common/types";

import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";

import ConnectCta from "./ConnectCta";

interface IntegrationNotConnectedProps {
  cta: {
    label?: string;
    href?: string;
    onClick?: () => void;
    disabled?: boolean;
    tooltip?: string;
  };
  heading?: string;
  provider: Integration;
}

const IntegrationNotConnected = ({
  cta,
  heading,
  provider,
}: IntegrationNotConnectedProps) => {
  const headingContent =
    heading ??
    (provider.isDisabled
      ? `${provider.displayName} is disabled`
      : `${provider.displayName} is not connected`);

  const subtext = provider.isDisabled
    ? "Your Workspace has restricted access to this integration"
    : `Click "${cta.label ?? "Connect"}" to get started!`;

  return (
    <IntegrationDetailContent padding={2} flex={1}>
      <EmptyStateContainer backgroundColor="transparent.white.50">
        <EmptyStateIcon Icon={IntersectSquare} />
        <EmptyStateTitle>{headingContent}</EmptyStateTitle>
        <EmptyStateSubtext>{subtext}</EmptyStateSubtext>
        {!provider.isDisabled && <ConnectCta cta={cta} provider={provider} />}
      </EmptyStateContainer>
    </IntegrationDetailContent>
  );
};

export default IntegrationNotConnected;
